import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { LazyMedia } from '@/components';
import { numFormat } from '@/utils';

import Popover from 'antd/es/popover';
import clsx from 'clsx';
// import { WhaleItem } from '../../types';
import { TokenIcon } from '@/components/TokenIcon';
import style from './index.module.scss';
import { IconRcDefaultNft } from '@/assets/icon/token';
import cx from 'clsx';

//todo
const formatPercent = (percent: number) => {
  const result = (percent * 100).toFixed(2);
  if (result === '100.00') {
    return '100%';
  }
  return result + '%';
};

export const TopTokens = ({
  data,
  customItemClass,
}: {
  data: { logo_url?: string; symbol?: string; percent?: number; rate?: number }[];
  customItemClass?: string;
}) => {
  const { t } = useTranslation();

  const list = useMemo(
    () =>
      (data || [])
        .map(item => ({ ...item, percent: item.percent || item.rate || 0 }))
        .filter(item => item.percent > 0.05)
        .sort((m, n) => n.percent - m.percent)
        .slice(0, 3),
    [data],
  );
  if (!list?.length) {
    return null;
  }
  return (
    <>
      <div className={cx(style.tagList)}>
        {list?.map((item: any) => {
          return (
            <Popover
              key={item.id}
              getPopupContainer={dom => dom}
              overlayClassName={style.popupOverlayStyle}
              content={
                <div className={style.popover}>
                  <div className={style.item}>
                    <div className={style.label}>{t('Stats.1c7v89')}</div>
                    <div className={clsx(style.value, style.token)}>
                      <TokenIcon
                        src={item.logo_url}
                        symbol={item.symbol}
                        className={style.tokenIcon}
                      />
                      {item.symbol}
                    </div>
                  </div>
                  <div className={style.item}>
                    <div className={style.label}>{t('Stats.1d2jpt')}</div>
                    <div className={style.value}>${numFormat(item.usd_value, 0)}</div>
                  </div>
                  <div className={style.item}>
                    <div className={style.label}>%</div>
                    <div className={style.value}>{formatPercent(item.percent)}</div>
                  </div>
                </div>
              }>
              <div className={cx(style.tag, customItemClass)} onClick={e => e.stopPropagation()}>
                <TokenIcon src={item.logo_url} symbol={item.symbol} className={style.tokenIcon} />
              </div>
            </Popover>
          );
        })}
      </div>
    </>
  );
};

export const TopProtocols = ({
  data,
  percentThreshold = 0.05,
}: {
  data: {
    logo_url?: string;
    usd_value: number;
    name?: string;
    percent?: number;
    rate?: number;
  }[];
  percentThreshold?: number;
}) => {
  const { t } = useTranslation();

  const list = useMemo(
    () =>
      (data || [])
        .map(item => ({ ...item, percent: item.percent || item.rate || 0 }))
        .filter(item => item.percent > percentThreshold)
        .sort((m, n) => n.percent - m.percent)
        .slice(0, 3),
    [data, percentThreshold],
  );
  if (list.length <= 0) {
    return null;
  }
  return (
    <>
      <div className={cx(style.tagList)}>
        {list.map((item: any) => {
          return (
            <Popover
              key={item.id}
              getPopupContainer={dom => dom}
              overlayClassName={style.popupOverlayStyle}
              content={
                <div className={style.popover}>
                  <div className={style.item}>
                    <div className={style.label}>{t('Stats.1jqodyw')}</div>
                    <div className={clsx(style.value, style.token)}>
                      <TokenIcon
                        src={item.logo_url}
                        symbol={item.symbol}
                        className={style.tokenIcon}
                      />
                      {item.name}
                    </div>
                  </div>
                  <div className={style.item}>
                    <div className={style.label}>{t('Stats.1d2jpt')}</div>
                    <div className={style.value}>${numFormat(item.usd_value, 0)}</div>
                  </div>
                  <div className={style.item}>
                    <div className={style.label}>%</div>
                    <div className={style.value}>{formatPercent(item.percent)}</div>
                  </div>
                </div>
              }>
              <div className={cx(style.tag)} onClick={e => e.stopPropagation()}>
                <TokenIcon src={item.logo_url} symbol={item.symbol} className={style.tokenIcon} />
              </div>
            </Popover>
          );
        })}
      </div>
    </>
  );
};

export const TopCollections = ({ data }: { data: any[] }) => {
  const { t } = useTranslation();

  const list = useMemo(
    () =>
      (data || [])
        .slice(0)
        .sort((m, n) => (!m.rank ? 1 : !n.rank ? 1 : m.rank - n.rank))
        .slice(0, 3),
    [data],
  );
  if (list.length <= 0) {
    return null;
  }
  return (
    <>
      <div className={cx(style.tagList, style.collectionList)}>
        {list?.map((item: any) => {
          return (
            <Popover
              key={item.id}
              overlayClassName={style.popupOverlayStyle}
              getPopupContainer={dom => dom}
              content={
                <div className={style.popover}>
                  <div className={style.item}>
                    <div className={style.label}>{t('Stats.464i4e')}</div>
                    <div className={clsx(style.value, style.token)}>
                      <LazyMedia
                        src={item.logo_url}
                        type={'image'}
                        className={style.nftIcon}
                        failedPlaceholder={<IconRcDefaultNft />}
                      />
                      {item.name}
                    </div>
                  </div>
                  <div className={style.item}>
                    <div className={style.label}>{t('Stats.lx5d4s')}</div>
                    <div className={style.value}>x{item.amount}</div>
                  </div>
                </div>
              }>
              <div>
                <LazyMedia
                  onClick={e => e.stopPropagation()}
                  src={item.logo_url}
                  type={'image'}
                  className={style.nftIcon}
                  failedPlaceholder={<IconRcDefaultNft />}
                />
              </div>
            </Popover>
          );
        })}
      </div>
    </>
  );
};
